// Simple validation in case the URL returns an HTML page instead of the token
const isValidCSRFToken = (token: string) => !token.includes('<');

export async function fetchCSRFToken() {
  const response = await fetch('/v2/xsrf/token').then((res) => res.text());

  if (!isValidCSRFToken(response)) {
    throw new Error('Could not obtain a valid CSRF token');
  }

  return response;
}
